import { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import "./MobileDropdown.css";

const MobileDropdown = ({ handleClose }) => {
  const [openMain, setOpenMain] = useState("");
  const [openBlock, setOpenBlock] = useState("");
  const location = useLocation();

  const blockchainRoutes = [
    "/service/blockchain-development",
    "/service/blockchain-consulting",
    "/service/ethereum-blockchain-development",
    "/service/dapp-development",
    "/service/smart-contract-development",
  ];

  const cryptoRoutes = [
    "/service/cryptocurrency-development",
    "/service/cryptowallet-development",
  ];

  const cryptoexchangeRoutes = ["/service/cryptoexchange-development"];

  const nftRoutes = [
    "/service/nft-marketplace",
    // "/service/nft-token-development",
    "/service/white-label-nft",
  ];

  const web3Routes = [
    "/service/web3-dapp-development",
    "/service/web3-consulting-service",
  ];

  const metaverseRoutes = [
    "/service/metaverse-development",
    "/service/metaverse-game-development",
    "/service/playtoearn-game-development",
  ];

  const industriesRoutes = [
    "/service/logistics",
    "/service/finance",
    "/service/insurance",
  ];

  const softwareRoutes = [
    "/service/web-application",
    "/service/software-development",
    "/service/mobile-application",
  ];

  const isBlockchainActive =
    blockchainRoutes.includes(location.pathname) ||
    cryptoRoutes.includes(location.pathname) ||
    cryptoexchangeRoutes.includes(location.pathname) ||
    nftRoutes.includes(location.pathname) ||
    web3Routes.includes(location.pathname) ||
    metaverseRoutes.includes(location.pathname) ||
    industriesRoutes.includes(location.pathname);

  const isBlockchainSubActive = blockchainRoutes.includes(location.pathname);
  const isCryptoActive = cryptoRoutes.includes(location.pathname);
  const isCryptoexchangeActive = cryptoexchangeRoutes.includes(location.pathname);
  const isNftActive = nftRoutes.includes(location.pathname);
  const isweb3Active = web3Routes.includes(location.pathname);
  const ismetaverseActive = metaverseRoutes.includes(location.pathname);
  const isindustriesActive = industriesRoutes.includes(location.pathname);
  const isSoftwareActive = softwareRoutes.includes(location.pathname);

  useEffect(() => {
    const path = location.pathname;

    // Open main blockchain menu
    if (
      blockchainRoutes.includes(path) ||
      cryptoRoutes.includes(path) ||
      cryptoexchangeRoutes.includes(path) ||
      nftRoutes.includes(path) ||
      web3Routes.includes(path) ||
      metaverseRoutes.includes(path)||
      industriesRoutes.includes(path)
    ) {
      setOpenMain("blockchain");
    } else if (softwareRoutes.includes(path)) {
      setOpenMain("software");
    } else {
      setOpenMain("");
    }

    // Open correct sub menu
    if (blockchainRoutes.includes(path)) {
      setOpenBlock("blockchain");
    } else if (cryptoRoutes.includes(path)) {
      setOpenBlock("crypto");
    } else if (cryptoexchangeRoutes.includes(path)) {
      setOpenBlock("cryptoexchange");
    } else if (nftRoutes.includes(path)) {
      setOpenBlock("nft");
    } else if (web3Routes.includes(path)) {
      setOpenBlock("web3");
    } else if (metaverseRoutes.includes(path)) {
      setOpenBlock("meta");
    } else if (industriesRoutes.includes(path)) {
      setOpenBlock("industries");
    } else {
      setOpenBlock(""); // 🔥 IMPORTANT reset
    }
  }, [location.pathname]);

  const toggleMain = (menu) => {
    setOpenMain(openMain === menu ? "" : menu);
    setOpenBlock(""); // reset level-2
  };

  const toggleBlock = (menu) => {
    setOpenBlock(openBlock === menu ? "" : menu);
  };

  const closeAllMenus = () => {
    setOpenMain("");
    setOpenBlock("");
    handleClose();
  };

  return (
    <div className="mobile-menu" onClick={(e) => e.stopPropagation()}>
      {/* ================= BLOCKCHAIN ================= */}
      <div className="mobile-item">
        <div
          className={`mobile-title ${isBlockchainActive ? "active" : ""}`}
          onClick={() => toggleMain("blockchain")}
        >
          Blockchain
          <ArrowDropDownIcon
            className={openMain === "blockchain" ? "rotate" : ""}
          />
        </div>

        {openMain === "blockchain" && (
          <div className="mobile-submenu">
            {/* Blockchain */}
            <div
              className={`mobile-sub-title ${
                isBlockchainSubActive ? "active" : ""
              }`}
              onClick={() => toggleBlock("blockchain")}
            >
              Blockchain
              <KeyboardArrowDownIcon
                className={openBlock === "blockchain" ? "rotate" : ""}
              />
            </div>

            {openBlock === "blockchain" && (
              <ul className="list-unstyled">
                <li>
                  <NavLink
                    to="/service/blockchain-development"
                    className={({ isActive }) =>
                      isActive ? "active-link" : ""
                    }
                    onClick={closeAllMenus}
                  >
                    Blockchain Development
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/service/blockchain-consulting"
                    className={({ isActive }) =>
                      isActive ? "active-link" : ""
                    }
                    onClick={closeAllMenus}
                  >
                    Blockchain Consulting
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/service/ethereum-blockchain-development"
                    className={({ isActive }) =>
                      isActive ? "active-link" : ""
                    }
                    onClick={closeAllMenus}
                  >
                    Ethereum Development
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/service/dapp-development"
                    className={({ isActive }) =>
                      isActive ? "active-link" : ""
                    }
                    onClick={closeAllMenus}
                  >
                    DApp Development
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/service/smart-contract-development"
                    className={({ isActive }) =>
                      isActive ? "active-link" : ""
                    }
                    onClick={closeAllMenus}
                  >
                    Smart Contract Development
                  </NavLink>
                </li>
              </ul>
            )}

            {/* Cryptocurrency */}
            <div
              className={`mobile-sub-title ${isCryptoActive ? "active" : ""}`}
              onClick={(e) => {
                e.stopPropagation();
                toggleBlock("crypto");
              }}
            >
              Cryptocurrency
              <KeyboardArrowDownIcon
                className={openBlock === "crypto" ? "rotate" : ""}
              />
            </div>

            {openBlock === "crypto" && (
              <ul className="list-unstyled">
                <li>
                  <NavLink
                    to="/service/cryptocurrency-development"
                    className={({ isActive }) =>
                      isActive ? "active-link" : ""
                    }
                    onClick={closeAllMenus}
                  >
                    Token Development
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/service/cryptowallet-development"
                    className={({ isActive }) =>
                      isActive ? "active-link" : ""
                    }
                    onClick={closeAllMenus}
                  >
                    Wallet Development
                  </NavLink>
                </li>
              </ul>
            )}

            {/* Cryptocurrency Exchange*/}
            <div
              className={`mobile-sub-title ${
                isCryptoexchangeActive ? "active" : ""
              }`}
              onClick={(e) => {
                e.stopPropagation();
                toggleBlock("cryptoexchange");
              }}
            >
              Crypto Exchange
              <KeyboardArrowDownIcon
                className={openBlock === "cryptoexchange" ? "rotate" : ""}
              />
            </div>

            {openBlock === "cryptoexchange" && (
              <ul className="list-unstyled">
                <li>
                  <NavLink
                    to="/service/cryptoexchange-development"
                    className={({ isActive }) =>
                      isActive ? "active-link" : ""
                    }
                    onClick={closeAllMenus}
                  >
                    Exchange Development
                  </NavLink>
                </li>
              </ul>
            )}

            {/* NFT */}
            <div
              className={`mobile-sub-title ${isNftActive ? "active" : ""}`}
              onClick={(e) => {
                e.stopPropagation();
                toggleBlock("nft");
              }}
            >
              NFT
              <KeyboardArrowDownIcon
                className={openBlock === "nft" ? "rotate" : ""}
              />
            </div>

            {openBlock === "nft" && (
              <ul className="list-unstyled">
                <li>
                  <NavLink
                    to="/service/nft-marketplace"
                    className={({ isActive }) =>
                      isActive ? "active-link" : ""
                    }
                    onClick={closeAllMenus}
                  >
                    Marketplace Development
                  </NavLink>
                </li>
                {/* <li>
                  <NavLink
                    to="/service/nft-token-development"
                    className={({ isActive }) =>
                      isActive ? "active-link" : ""
                    }
                    onClick={closeAllMenus}
                  >
                    NFT Minting Platform
                  </NavLink>
                </li> */}
                {/* <li>
                  <NavLink to="">NFT Game Development</NavLink>
                </li> */}
                <li>
                  <NavLink
                    to="/service/white-label-nft"
                    className={({ isActive }) =>
                      isActive ? "active-link" : ""
                    }
                    onClick={closeAllMenus}
                  >
                    White Label NFT
                  </NavLink>
                </li>
              </ul>
            )}

            {/* WEB3 */}
            <div
              className={`mobile-sub-title ${isweb3Active ? "active" : ""}`}
              onClick={(e) => {
                e.stopPropagation();
                toggleBlock("web3");
              }}
            >
              Web3
              <KeyboardArrowDownIcon
                className={openBlock === "web3" ? "rotate" : ""}
              />
            </div>

            {openBlock === "web3" && (
              <ul className="list-unstyled">
                <li>
                  <NavLink
                    to="/service/web3-dapp-development"
                    className={({ isActive }) =>
                      isActive ? "active-link" : ""
                    }
                    onClick={closeAllMenus}
                  >
                    Web3 Dapp Development
                  </NavLink>
                </li>
                {/* <li>
                  <NavLink
                    to="/service/web3game-development"
                    className={({ isActive }) =>
                      isActive ? "active-link" : ""
                    }
                    onClick={closeAllMenus}
                  >
                    DAO Development
                  </NavLink>
                </li> */}
                <li>
                  <NavLink
                    to="/service/web3-consulting-service"
                    className={({ isActive }) =>
                      isActive ? "active-link" : ""
                    }
                    onClick={closeAllMenus}
                  >
                    Web3 Consulting
                  </NavLink>
                </li>
              </ul>
            )}

            {/* Metaverse */}
            <div
              className={`mobile-sub-title ${
                ismetaverseActive ? "active" : ""
              }`}
              onClick={(e) => {
                e.stopPropagation();
                toggleBlock("meta");
              }}
            >
              Metaverse
              <KeyboardArrowDownIcon
                className={openBlock === "meta" ? "rotate" : ""}
              />
            </div>

            {openBlock === "meta" && (
              <ul className="list-unstyled">
                <li>
                  <NavLink
                    to="/service/metaverse-development"
                    className={({ isActive }) =>
                      isActive ? "active-link" : ""
                    }
                    onClick={closeAllMenus}
                  >
                    Metaverse Development
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/service/metaverse-game-development"
                    className={({ isActive }) =>
                      isActive ? "active-link" : ""
                    }
                    onClick={closeAllMenus}
                  >
                    Games Development
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/service/playtoearn-game-development"
                    className={({ isActive }) =>
                      isActive ? "active-link" : ""
                    }
                    onClick={closeAllMenus}
                  >
                    P2E Game Development
                  </NavLink>
                </li>
              </ul>
            )}

            {/* Industries */}
            <div
              className={`mobile-sub-title ${
                isindustriesActive ? "active" : ""
              }`}
              onClick={(e) => {
                e.stopPropagation();
                toggleBlock("industries");
              }}
            >
              Industries
              <KeyboardArrowDownIcon
                className={openBlock === "industries" ? "rotate" : ""}
              />
            </div>

            {openBlock === "industries" && (
              <ul className="list-unstyled">
                <li>
                  <NavLink
                    to="/service/logistics"
                    className={({ isActive }) =>
                      isActive ? "active-link" : ""
                    }
                    onClick={closeAllMenus}
                  >
                    Supplychain & Logistics
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/service/finance"
                    className={({ isActive }) =>
                      isActive ? "active-link" : ""
                    }
                    onClick={closeAllMenus}
                  >
                    Finance
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/service/insurance"
                    className={({ isActive }) =>
                      isActive ? "active-link" : ""
                    }
                    onClick={closeAllMenus}
                  >
                    Insurance
                  </NavLink>
                </li>                
              </ul>
            )}
          </div>
        )}
      </div>

      {/* ================= GENERATIVE AI (1 LEVEL) ================= */}
      <div className="mobile-item">
        <div
          className="mobile-title"
          onClick={(e) => {
            e.stopPropagation();
            toggleMain("generativeai");
          }}
        >
          Generative AI
          <ArrowDropDownIcon
            className={openMain === "generativeai" ? "rotate" : ""}
          />
        </div>
        <div className="mobile-submenu">
          {openMain === "generativeai" && (
            <ul className="list-unstyled">
              <li>
                <NavLink to="/">Generative AI Development</NavLink>
              </li>
              <li>
                <NavLink to="/">Generative AI Consulting</NavLink>
              </li>
              <li>
                <NavLink to="/">Gen AI Integration Services</NavLink>
              </li>
              <li>
                <NavLink to="/">LLM Development</NavLink>
              </li>
              <li>
                <NavLink to="/">LLM Integration</NavLink>
              </li>
              <li>
                <NavLink to="/">AI Agents Development</NavLink>
              </li>
              <li>
                <NavLink to="/">MCP Development Company</NavLink>
              </li>
              <li>
                <NavLink to="/">Co-pilot Development</NavLink>
              </li>
            </ul>
          )}
        </div>
      </div>

      {/* ================= SOFTWARE (1 LEVEL) ================= */}
      <div className="mobile-item">
        <div
          className={`mobile-title ${isSoftwareActive ? "active" : ""}`}
          onClick={() => toggleMain("software")}
        >
          Software Development
          <ArrowDropDownIcon
            className={openMain === "software" ? "rotate" : ""}
          />
        </div>
        <div className="mobile-submenu">
          {openMain === "software" && (
            <ul className="list-unstyled">
              <li>
                <NavLink
                  to="/service/software-development"
                  className={({ isActive }) => (isActive ? "active-link" : "")}
                  onClick={closeAllMenus}
                >
                  Software Development
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/service/web-application"
                  className={({ isActive }) => (isActive ? "active-link" : "")}
                  onClick={closeAllMenus}
                >
                  Web Application
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/service/mobile-application"
                  className={({ isActive }) => (isActive ? "active-link" : "")}
                  onClick={closeAllMenus}
                >
                  Mobile Application
                </NavLink>
              </li>
            </ul>
          )}
        </div>
      </div>

      {/* ================= AI & ML (1 LEVEL) ================= */}
      <div className="mobile-item">
        <div
          className="mobile-title"
          onClick={(e) => {
            e.stopPropagation();
            toggleMain("ai");
          }}
        >
          AI & ML
          <ArrowDropDownIcon className={openMain === "ai" ? "rotate" : ""} />
        </div>
        <div className="mobile-submenu">
          {openMain === "ai" && (
            <ul className="list-unstyled">
              <li>
                <NavLink to="/">AI Development</NavLink>
              </li>
              <li>
                <NavLink to="/">AI App Development</NavLink>
              </li>
              <li>
                <NavLink to="/">AI Consulting</NavLink>
              </li>
              <li>
                <NavLink to="/">AI Software Development</NavLink>
              </li>
              <li>
                <NavLink to="/">ChatBot Development</NavLink>
              </li>
              <li>
                <NavLink to="/">Enterprise AI ChatBot</NavLink>
              </li>
              <li>
                <NavLink to="/">AI Chatbot Development</NavLink>
              </li>
              <li>
                <NavLink to="/">Machine Learning Development</NavLink>
              </li>
              <li>
                <NavLink to="/">AI Copilot Development</NavLink>
              </li>
              <li>
                <NavLink to="/">AI Agent Development</NavLink>
              </li>
              <li>
                <NavLink to="/">AI Deployment Services</NavLink>
              </li>
              <li>
                <NavLink to="/">AI Development Company</NavLink>
              </li>
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default MobileDropdown;
